module.exports = __webpack_public_path__ + "static/media/dollar.167cc366.svg";